"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Picture = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const app_1 = require("app");
const React = require("react");
const webexUI_1 = require("webexUI");
const Picture = ({ url, className, altText, mode, width, height, set, disableDeferImages, title, }) => {
    const [error, setError] = React.useState(false);
    const getSrc = React.useCallback((w, h) => `${url}?anchor=center&mode=${mode || 'crop'}&width=${w}${h ? '&height=' + h : ''}`, [mode, url]);
    const pictureSrcPropTitle = React.useMemo(() => (disableDeferImages ? 'srcSet' : 'data-srcset'), [disableDeferImages]);
    const imgProps = React.useMemo(() => {
        const altTextValue = altText || (title ? title.replace(/\s+/g, '-').toLocaleLowerCase() : '');
        return Object.assign(Object.assign({}, (disableDeferImages
            ? { src: getSrc(width, height) }
            : { 'data-src': getSrc(width, height), src: app_1.DEFAULT_SRCSET_VALUE })), { alt: altTextValue, className: `${className || ''} lazyload` });
    }, [altText, className, disableDeferImages, getSrc, height, width, title]);
    const handleFieldLoadingImage = (event) => {
        const imageElement = event.target;
        imageElement.parentElement.parentElement.classList.add('img-empty-wrapper');
        setError(true);
    };
    return ((0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: error ? ((0, jsx_runtime_1.jsx)("img", { src: "/static/icons/image-broken.svg", alt: altText, className: `img-error ${className || ''} lazyloaded`, "data-failed-image-src": url, style: {
                padding: '10%',
                objectFit: 'contain',
                filter: 'brightness(0) saturate(100%) invert(99%) sepia(1%) saturate(5645%) hue-rotate(182deg) brightness(83%) contrast(97%)',
            } })) : ((0, jsx_runtime_1.jsxs)("picture", { children: [(0, webexUI_1.safe)(set).map(item => {
                    const { maxWidth } = item;
                    const srcProps = Object.assign({ media: `(max-width: ${maxWidth || item.width - 1}px)`, [pictureSrcPropTitle]: getSrc(item.width, item.height) }, (disableDeferImages ? {} : { srcSet: app_1.DEFAULT_SRCSET_VALUE }));
                    return (0, jsx_runtime_1.jsx)("source", Object.assign({}, srcProps), item.width);
                }), (0, jsx_runtime_1.jsx)("img", Object.assign({}, imgProps, { onError: handleFieldLoadingImage, alt: altText }))] })) }));
};
exports.Picture = Picture;
